export default function(status, action, store = {}) {
  return {
    type: action,
    status,
    store
  };
}
